import React, { useState, useContext } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { AiOutlineClose } from 'react-icons/ai'
import _ from 'lodash'

import AppConfigContext from '../../../app_layout/app_config_context'
import { ApiHelper } from '../../../../helpers/apihelper'
import * as Constants from '../../../../helpers/constants'
import showToastNotification from '../../../widgets/toastify'

const initialState = {
  showAttachProductModal: false,
  loading: false
}

const OnAttachProductClicked = ({ user, product, planId, onSuccess }) => {

  const [attachProductState, setAttachProductState] = useState(initialState)

  const { client } = useContext(AppConfigContext)
  const handleAttach = () => {
    const requestBody = {
      co_user_id: user.user_id || user._id,
      product_id: planId,
      client_secret: Constants.CLIENT_SECRET
    }
    const body = _.pick(
      requestBody,
      ApiHelper(client, 'ATTACH_PRODUCT').API_BODY
    )
    setAttachProductState(prev => ({ ...prev, loading: true }))
    ApiHelper(client, 'ATTACH_PRODUCT')
      .API(client, body)
      .then(res => {
        if (res.status === Constants.CO_API.SUCCESS) {
          showToastNotification({
            message: res.data.message || 'User attached successfully',
            isSuccess: true
          })

          setAttachProductState(prev => ({
            ...prev,
            showAttachProductModal: false
          }))

          if (onSuccess) {
            onSuccess(user.user_id)
          }
        } else {
          showToastNotification({
            message: res?.message || 'Something went wrong',
            isSuccess: false
          })
        }

      })
      .catch((err) => {
        console.error(err)

        const message =
          err?.response?.data?.message ||
          err?.message ||
          'Something went wrong'

        showToastNotification({
          message,
          isSuccess: false
        })
      })
      .finally(() =>
        setAttachProductState(prev => ({ ...prev, loading: false }))
      )
  }
  if (!user || !product) return null
  return (
    <>
      <Button
        size="sm"
        variant="outline-primary"
        onClick={() =>
          setAttachProductState(prev => ({ ...prev, showAttachProductModal: true }))
        }
      >
        Attach
      </Button>
      <Modal
        show={attachProductState.showAttachProductModal}
        onHide={() =>
          setAttachProductState(prev => ({ ...prev, showAttachProductModal: false }))
        }
        backdrop="static"
      >
        <Modal.Header>
          <div className="d-flex justify-content-between w-100">
            <Modal.Title>Attach user</Modal.Title>
            <Button
              variant="link"
              className="p-0"
              onClick={() =>
                setAttachProductState(prev => ({ ...prev, showAttachProductModal: false }))
              }
            >
              <AiOutlineClose size={20} />
            </Button>
          </div>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to attach{' '}
          <span className='user-modal-info'>{user.name}</span>{' '}
          from{' '}
          <span className='user-modal-info'>{product.display_name}</span>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={() =>
              setAttachProductState(prev => ({ ...prev, showAttachProductModal: false }))
            }
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleAttach}
            disabled={attachProductState.loading}
          >
            {attachProductState.loading ? 'Attaching...' : 'Attach'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default OnAttachProductClicked